import { asHintId, type Hint } from '@/shared/stores';

import { PATIENT_PANEL_TABS_ANCHOR } from './anchors';

export const workspaceTabsHint: Hint = {
  id: asHintId('patient-workspace:tabs'),
  version: 1,
  priority: 80,
  anchor: PATIENT_PANEL_TABS_ANCHOR,
  copy: {
    title: 'Switch views for this patient',
    body: 'Each tab is a different lens — snapshot, chat, prior auths, and more. Use them to move between context without leaving the workspace.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
